/* =====================================================================
   MARSHAL — brand behaviour for Horizon
   =====================================================================

   Deliberately small. Horizon already ships smooth UX, a cart drawer,
   variant pickers and quick add; this adds only what Marshal's own
   sections need and nothing that duplicates the theme.

   NO LENIS HERE. The Next.js build used it for smooth scrolling, and it
   caused two separate bugs — overlays that couldn't be scrolled because
   Lenis swallowed the wheel event, and reveals that fired against a
   scroll position the browser didn't agree with. Horizon's native
   scrolling is good, and the trade (two classes of bug for a slight
   easing) isn't worth it inside a theme we don't fully control.
   ===================================================================== */
(function () {
  "use strict";

  var root = document.documentElement;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Tells the CSS that enhancement is on. Without it nothing is hidden,
  // so a JS failure costs animation and never content.
  root.classList.add("mw-js");

  function reveal(el) { el.classList.add("mw-revealed"); }

  /* Already on screen? Checked directly rather than waiting for an
     intersection event — an element that is ALREADY past the trigger
     line never crosses it, and so would stay invisible forever. That
     exact bug put a blank row in the middle of the FAQ on the previous
     build. */
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || root.clientHeight) * 0.95;
  }

  function initReveals() {
    var targets = [].slice
      .call(document.querySelectorAll("[data-mw-reveal]"))
      .filter(function (el) { return !el.hasAttribute("data-mw-bound"); });

    if (!targets.length) return;
    targets.forEach(function (el) { el.setAttribute("data-mw-bound", ""); });

    if (reduced) { targets.forEach(reveal); return; }

    var pending = [];
    targets.forEach(function (el) { inView(el) ? reveal(el) : pending.push(el); });
    if (!pending.length) return;

    if (!("IntersectionObserver" in window)) { pending.forEach(reveal); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var parent = e.target.closest("[data-mw-stagger]");
        if (parent) {
          var sibs = [].slice.call(parent.querySelectorAll("[data-mw-reveal]"));
          e.target.style.transitionDelay = Math.min(sibs.indexOf(e.target), 6) * 0.08 + "s";
        }
        reveal(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: "0px 0px -5% 0px" });

    pending.forEach(function (el) { io.observe(el); });
  }

  /* Nothing stays invisible for more than three seconds, whatever goes
     wrong above. */
  function sweep() {
    setTimeout(function () {
      [].forEach.call(
        document.querySelectorAll("[data-mw-reveal]:not(.mw-revealed)"),
        function (el) { if (inView(el)) reveal(el); }
      );
    }, 3000);
  }

  /* Tile videos. Started on approach rather than on load, and only once
     visible — Safari rejects autoplay otherwise. `muted` is set as a
     PROPERTY as well as an attribute because iOS only honours it that
     way at play() time. */
  function initVideos() {
    var vids = document.querySelectorAll("[data-mw-video]");
    if (!vids.length) return;

    function start(v) {
      if (v.dataset.started) return;
      v.dataset.started = "1";
      v.muted = true;
      v.setAttribute("muted", "");
      if (!v.querySelector("source") && v.dataset.src) {
        var s = document.createElement("source");
        s.src = v.dataset.src;
        s.type = "video/mp4";
        v.appendChild(s);
        v.load();
      }
      var p = v.play();
      // A tile that can't autoplay shows its poster — a still
      // photograph, not a broken element.
      if (p && p.catch) p.catch(function () {});
    }

    if (!("IntersectionObserver" in window)) { [].forEach.call(vids, start); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { start(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "200px" });
    [].forEach.call(vids, function (v) { io.observe(v); });
  }

  function boot() { initReveals(); initVideos(); sweep(); }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  // Horizon re-renders sections in the theme editor; re-bind so reveals
  // and videos work on a freshly dropped section without a reload.
  document.addEventListener("shopify:section:load", boot);
})();
